import { render, staticRenderFns } from "./two-fa-settings.vue?vue&type=template&id=33edb7c5&"
import script from "./two-fa-settings.vue?vue&type=script&lang=js&"
export * from "./two-fa-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports